var styleDataHash = "870aba6c";
const injectCss = () => {
  var css = `.AB3Gw{flex:1 1 auto;overflow:auto}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var swatch_color_picker_default = {
  "content": "AB3Gw"
};
export {
  swatch_color_picker_default as default,
  injectCss
};
//# sourceMappingURL=swatch-color-picker-scss.js.map
